export const maritalStatusEnum = {
  "Solteira(o)": "1",
  "Casada(o)": "2",
  "Divorciada(o)": "3",
  "Viúva(o)": "4",
};

export const councilTypeEnum = {
  CRM: "1",
  CRO: "2",
  CREFITO: "3",
  COREN: "4",
  ESTETICISTA: "5",
  CRBM: "6",
  CRN: "7",
  CRF: "8",
};
